<script>
  import { onMount } from 'svelte'
  import { tenantStore } from '../../state/store'
  import UpdatePayment from '../../components/UpdatePayment.svelte'
  import CancelSubscription from '../../components/CancelSubscription.svelte'
  import ViewContainer from '../../components/ViewContainer.svelte'
  import Spinner from '../../components/Spinner.svelte'
  import { t } from '../../i18n/i18n'
  import UpdatePlan from '../../components/UpdatePlan.svelte';
  import { getTenantData } from '../../state/actions'

  let promise

  onMount(() => {
    promise = getTenantData()
  })

</script>

<style>

  h1 {
    margin-bottom: 1rem;
  }

  p {
    text-transform: capitalize;
    font-size: 1.4rem;
  }

  div p:first-child {
  color: var(--greylight);
  font-size: 1.2rem;
  font-weight: bold;
  text-transform: uppercase;
}

  section {
    margin: 0;
    display: flex;
    flex-direction: column;
    padding: 2rem 0;
    border-bottom: 1px solid var(--bg-grey);
  }

  @media (min-width: 420px) {
    header {
      display: flex;
      align-items: center;
    }
    header div {
      padding-left: 2rem;
    }

    header div:first-of-type {
      margin-left: auto;
    }
  }
</style>


<ViewContainer>
  {#await promise}
    <Spinner />
  {:then}
    <header>
      <h1>{$t.settings}</h1>
      <div>
        <p>{$t['Company Name']}</p>
        <p>{$tenantStore.name}</p>
      </div>
      <div>
        <p>{$t['Primary Email']}</p>
        <p>{$tenantStore.email}</p>
      </div>
    </header>
    <article>
      <section class="g-card-list-wrapper">
        <UpdatePlan />
      </section>
      <section class="g-card-list-wrapper">
        <UpdatePayment />
      </section>
      <section class="g-card-list-wrapper">
        <CancelSubscription />
      </section>
    </article>
  {/await}
</ViewContainer>
